import ReportsTravelRuleTableHeader from './ReportsTravelRuleTableHeader'

export default ReportsTravelRuleTableHeader
